import { TimelineSection } from '../section-listing.model';

export class SessionSection extends TimelineSection {
  sessionId: number;
  engagement: number;
  comprehension: number;
  lessonSummary: string;
  learnerComments: string;
  attendance: string;
  startTime: any;
  endTime: any;
  sessionType: string;
  subject: string;
}
